import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { ReactNode } from 'react';

interface IProps {
  open: boolean;
  title: string;
  children: ReactNode;
  handleYes: () => void;
  handleNo: () => void;
}

const ConfirmationModal = ({ open, title, children, handleYes, handleNo }: IProps) => (
  <Dialog open={open}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>{children}</DialogContent>
    <DialogActions>
      <Button onClick={handleNo} autoFocus variant="outlined" data-testid="confirmation-modal-no-button">
        No
      </Button>
      <Button onClick={handleYes} variant="contained" color="error" data-testid="confirmation-modal-yes-button">
        Yes
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmationModal;
